import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useProcurementRuntime } from "../runtime/procurement-runtime";
import { DemandTargetAllocationGroups } from "../screens/demand-target-allocation-groups";
import {
  destinationByPath,
  ProcurementDestinationRoute,
} from "../screens/procurement-shell";

export const Route = createFileRoute("/demand-target-allocation-groups")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { origin?: string; group?: string } => ({
    ...(typeof search.origin === "string" ? { origin: search.origin } : {}),
    ...(typeof search.group === "string" ? { group: search.group } : {}),
  }),
  component: AllocationGroupsRoute,
});
function AllocationGroupsRoute() {
  const { origin, group } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [editorName, setEditorName] = useState("");
  const { demands } = useProcurementRuntime();
  return (
    <ProcurementDestinationRoute
      destination={destinationByPath["/demand-target-allocation-groups"]}
      {...(group
        ? {
            recordBreadcrumb: {
              label: editorName || "SO / PO",
              onBack: () =>
                void navigate({
                  search: origin ? { origin } : {},
                  replace: true,
                }),
            },
          }
        : {})}
    >
      <DemandTargetAllocationGroups
        demands={demands}
        originID={origin}
        requestedGroupID={group}
        onOpenGroup={(ID) =>
          void navigate({
            search: { ...(origin ? { origin } : {}), group: ID },
          })
        }
        onEditorNameChange={setEditorName}
        onSaved={() =>
          void navigate({
            search: origin ? { origin } : {},
            replace: true,
            ignoreBlocker: true,
          })
        }
      />
    </ProcurementDestinationRoute>
  );
}
